var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.843,
    height: 18.976,
    viewBox: "0 0 16.843 18.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Duplicate",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2722",
    "data-name": "Group 2722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M11.6,18.976h-9.2A2.408,2.408,0,0,1,0,16.589V4.874A2.4,2.4,0,0,1,2.392,2.481h9.2a2.4,2.4,0,0,1,2.4,2.392V16.585A2.406,2.406,0,0,1,11.6,18.976ZM2.4,3.922a.96.96,0,0,0-.954.955V16.585a.96.96,0,0,0,.955.949h9.2a.96.96,0,0,0,.954-.952V4.874a.958.958,0,0,0-.955-.952ZM16.122,15.007a.721.721,0,0,1-.721-.721V3.112a1.672,1.672,0,0,0-1.67-1.67H4.7A.721.721,0,1,1,4.7,0h9.035a3.115,3.115,0,0,1,3.112,3.112V14.287A.721.721,0,0,1,16.122,15.007Z",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.f4f807252730a83d5fa29db3dacde086.svg";
export { ForwardRef as ReactComponent };